module.exports = __webpack_public_path__ + "static/media/onboarding-3.e4873fa9.png";